import { render, staticRenderFns } from "./register-card.vue?vue&type=template&id=59225fb4&scoped=true&"
import script from "./register-card.vue?vue&type=script&lang=js&"
export * from "./register-card.vue?vue&type=script&lang=js&"
import style0 from "./register-card.vue?vue&type=style&index=0&id=59225fb4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59225fb4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VForm } from 'vuetify/lib/components/VForm';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VCardText,VForm,VTextField})
